var ubiTypeahead = require('angular-ui-bootstrap');
require('../lib/treeview/treeview.js');
require('../lib/draganddrop.js');

angular.module('cn', ['ngResource', 'draganddrop', 'treeView', ubiTypeahead]);

require('./cncrud.js');
require('./cntree.js');
require('./cnlist.js');
require('./cnmain.js');
require('./accountedit.js');
require('./retailers.js');
require('./createnetwork.js');
require('./deletenetwork.js');
require('./networktree.js');
require('./services/accountsRepository.js');
require('./services/networksRepository.js');
require('./services/networkRelationsRepository.js');
require('./services/networkTypesRepository.js');
require('./../lib/promisecache.js');
require('./../lib/modalconfirm.js');

angular.module('cn')

.config(['$routeProvider', function($routeProvider) {
  $routeProvider
  .when('/networks', {
    constoller: 'none',
    template: '<cn-main></cn-main>'
  })
  .when('/networks/crud/:id', {
    constoller: 'none',
    template: '<cn-crud></cn-crud>'
  });
}]);



// WEBPACK FOOTER //
// ./src/cn/cn.js